import axios from 'axios';

// Use environment variable for API URL, fallback to Railway production URL
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://eka-company-production.up.railway.app/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Projects API
export const getProjects = (params) => api.get('/projects/', { params });
export const getProject = (slug) => api.get(`/projects/${slug}/`);
export const getCategories = () => api.get('/categories/');

// Services API
export const getServices = () => api.get('/services/');
export const getService = (slug) => api.get(`/services/${slug}/`);

// Blog API
export const getBlogPosts = (params) => api.get('/blog/posts/', { params });
export const getBlogPost = (slug) => api.get(`/blog/posts/${slug}/`);
export const getBlogCategories = () => api.get('/blog/categories/');

// Portfolio API
export const getPortfolioItems = (params) => api.get('/portfolio/items/', { params });
export const getPortfolioItem = (slug) => api.get(`/portfolio/items/${slug}/`);
export const getPortfolioCategories = () => api.get('/portfolio/categories/');

// Contact API
export const submitContactMessage = (data) => api.post('/contact/messages/', data);
export const getCompanyInfo = () => api.get('/contact/info/primary/');

export default api;





